export type FolderTreeItem = {
  children: FolderTreeItem[];
  en: string;
  nb: string;
  key: string;
};

export const foldersTree: FolderTreeItem[] = [
  {
    children: [
      {
        children: [],
        en: 'Company registration certificate',
        nb: 'Registreringsdokumenter',
        key: 'CompanyRegistrationCertificate',
      },
      {
        children: [],
        en: 'By-laws',
        nb: 'Vedtekter',
        key: 'By-laws',
      },
      {
        children: [],
        en: 'Rules of procedures for the board',
        nb: 'Styreinstruks',
        key: 'RulesOfProceduresForTheBoard',
      },
      {
        children: [],
        en: 'Business plans',
        nb: 'Forretningsplaner',
        key: 'BusinessPlans',
      },
      {
        children: [],
        en: 'Company presentations',
        nb: 'Presentasjoner',
        key: 'CompanyPresentations',
      },
      {
        children: [],
        en: 'Board authorizations',
        nb: 'Fullmakter til styret',
        key: 'BoardAuthorizations',
      },
    ],
    en: 'Corporate information',
    nb: 'Selskapsinformasjon',
    key: 'CorporateInformation',
  },
  {
    children: [
      {
        children: [],
        en: 'Shareholder Register',
        nb: 'Aksjeeierbok',
        key: 'ShareRegister',
      },
      {
        children: [],
        en: 'Option agreements',
        nb: 'Opsjonsavtaler',
        key: 'OptionAgreements',
      },
      {
        children: [],
        en: 'Convertible agreements',
        nb: 'Konvertible lån',
        key: 'ConvertibleAgreements',
      },
      {
        children: [],
        en: 'Equity issues',
        nb: 'Kapitalforhøyelser',
        key: 'EquityIssues',
      },
      {
        children: [],
        en: 'Shareholder agreements',
        nb: 'Aksjonæravtaler',
        key: 'ShareholderAgreements',
      },
    ],
    en: 'Ownership and investments',
    nb: 'Eierskap og investeringer',
    key: 'OwnershipAndInvestments',
  },
  {
    children: [
      {
        children: [],
        en: 'Annual statements',
        nb: 'Årsregnskap',
        key: 'AnnualStatements',
      },
      {
        children: [],
        en: 'Loan agreements',
        nb: 'Låneavtaler',
        key: 'LoanAgreements',
      },
      {
        children: [],
        en: 'Lease agreements',
        nb: 'Leasingavtaler',
        key: 'LeaseAgreements',
      },
      {
        children: [],
        en: 'Valuations',
        nb: 'Verdivurderinger',
        key: 'Valuations',
      },
      {
        children: [],
        en: 'Budgets',
        nb: 'Budsjetter',
        key: 'Budgets',
      },
      {
        children: [],
        en: 'Reports',
        nb: 'Regnskapsrapporter',
        key: 'Reports',
      },
      {
        children: [],
        en: 'Auditors reports',
        nb: 'Revisjonsrapporter',
        key: 'AuditorsReports',
      },
      {
        children: [],
        en: 'Auditors letters',
        nb: 'Brev fra revisor',
        key: 'AuditorsLetters',
      },
      {
        children: [],
        en: 'Taxes and fees',
        nb: 'Skatter og avgifter',
        key: 'TaxesAndFees',
      },
    ],
    en: 'Financial information',
    nb: 'Finansiell informasjon',
    key: 'FinancialInformation',
  },
  {
    children: [
      {
        children: [],
        en: 'Suppliers',
        nb: 'Leverandører',
        key: 'Suppliers',
      },
      {
        children: [],
        en: 'Customers',
        nb: 'Kunder',
        key: 'Customers',
      },
      {
        children: [],
        en: 'Distribution',
        nb: 'Distribusjon',
        key: 'Distribution',
      },
      {
        children: [],
        en: 'Partner',
        nb: 'Partner',
        key: 'Partner',
      },
    ],
    en: 'Agreements',
    nb: 'Kontrakter',
    key: 'Agreements',
  },
  {
    children: [
      {
        children: [],
        en: 'Employment contracts',
        nb: 'Ansettelsesavtaler',
        key: 'EmploymentContracts',
      },
      {
        children: [],
        en: 'Employees Insurance',
        nb: 'Personalforsikring',
        key: 'EmployeesInsurance',
      },
      {
        children: [],
        en: 'Pension arrangements',
        nb: 'Pensjonsavtaler',
        key: 'PensionArrangements',
      },
      {
        children: [],
        en: 'Unions',
        nb: 'Fagforeninger',
        key: 'Unions',
      },
      {
        children: [],
        en: 'HSE',
        nb: 'HMS',
        key: 'HSE',
      },
      {
        children: [],
        en: 'Option agreements',
        nb: 'Opsjonsavtaler',
        key: 'OptionAgreements',
      },
      {
        children: [],
        en: 'Course and training',
        nb: 'Kurs og opplæring',
        key: 'CourseAndTraining',
      },
    ],
    en: 'Employees',
    nb: 'Ansatte',
    key: 'Employees',
  },
  {
    children: [
      {
        children: [],
        en: 'Patents',
        nb: 'Patenter',
        key: 'Patents',
      },
      {
        children: [],
        en: 'License Agreements',
        nb: 'Lisensavtaler',
        key: 'LicenseAgreements',
      },
      {
        children: [],
        en: 'Trade marks',
        nb: 'Varemerker',
        key: 'TradeMarks',
      },
      {
        children: [],
        en: 'Domain names',
        nb: 'Domenenavn',
        key: 'DomainNames',
      },
      {
        children: [],
        en: 'Software licenses held',
        nb: 'Programvarelisenser innkjøpt',
        key: 'SoftwareLicensesHeld',
      },
      {
        children: [],
        en: 'Software licenses developed',
        nb: 'Programvarelisenser utviklet',
        key: 'SoftwareLicensesDeveloped',
      },
    ],
    en: 'Intellectual property rights',
    nb: 'Immaterielle rettigheter',
    key: 'IntellectualPropertyRights',
  },
  {
    children: [
      {
        children: [],
        en: 'Insurance overview',
        nb: 'Forsikringsoversikt',
        key: 'InsuranceOverview',
      },
      {
        children: [],
        en: 'Insurance policies',
        nb: 'Forsikringspoliser',
        key: 'InsurancePolicies',
      },
    ],
    en: 'Insurance',
    nb: 'Forsikringer',
    key: 'Insurance',
  },
  {
    children: [
      {
        children: [],
        en: 'Licenses',
        nb: 'Lisenser og konsesjoner',
        key: 'Licenses',
      },
    ],
    en: 'Regulatory',
    nb: 'Regulatoriske forhold',
    key: 'Regulatory',
  },
  {
    children: [
      {
        children: [],
        en: 'Current disputes',
        nb: 'Pågående tvister',
        key: 'CurrentDisputes',
      },
      {
        children: [],
        en: 'Historic disputes',
        nb: 'Historiske tvister',
        key: 'HistoricDisputes',
      },
    ],
    en: 'Disputes',
    nb: 'Tvister',
    key: 'Disputes',
  },
  {
    children: [
      {
        children: [],
        en: 'Environment',
        nb: 'Miljø',
        key: 'Environment',
      },
      {
        children: [],
        en: 'Risk management and internal control',
        nb: 'Risikostyring og internkontroll',
        key: 'RiskManagementAndInternalControl',
      },
      {
        children: [],
        en: 'Research and development',
        nb: 'Forskning og utvikling',
        key: 'ResearchAndDevelopment',
      },
      {
        children: [],
        en: 'Due diligence reports',
        nb: 'Due diligence-rapporter',
        key: 'DueDiligenceReports',
      },
    ],
    en: 'Internal control',
    nb: 'Internkontroll',
    key: 'Other',
  },
];

export const foldersTreeDD: FolderTreeItem[] = [
  {
    en: '01 Investor Presentations',
    nb: '01 Investor Presentations',
    key: 'DD01_Investor_Presentations',
    children: [],
  },
  {
    en: '02 General',
    nb: '02 General',
    key: 'DD02_General',
    children: [
      {
        en: '01 Articles of Association',
        nb: '01 Articles of Association',
        key: 'DD01_Articles_of_Association',
        children: [],
      },
      {
        en: '02 Incorporation Documents',
        nb: '02 Incorporation Documents',
        key: 'DD02_Incorporation_Documents',
        children: [],
      },
      {
        en: '03 CAP Table',
        nb: '03 CAP Table',
        key: 'DD03_CAP_Table',
        children: [],
      },
      {
        en: '04 Shareholder Agreements',
        nb: '04 Shareholder Agreements',
        key: 'DD04_Shareholder_Agreements',
        children: [],
      },
      {
        en: '05 Minutes from Board Meetings',
        nb: '05 Minutes from Board Meetings',
        key: 'DD05_Minutes_from_Board_Meetings',
        children: [],
      },
      {
        en: '06 Overview of Option Agreements',
        nb: '06 Overview of Option Agreements',
        key: 'DD06_Overview_of_Option_Agreements',
        children: [],
      },
    ],
  },
  {
    en: '03 HR',
    nb: '03 HR',
    key: 'DD03_HR',
    children: [
      {
        en: '01 List of Employees incl Contractors',
        nb: '01 List of Employees incl Contractors',
        key: 'DD01_List_of_Employees_incl_Contractors',
        children: [],
      },
      {
        en: '02 Employment Contracts',
        nb: '02 Employment Contracts',
        key: 'DD02_Employment_Contracts',
        children: [],
      },
      {
        en: '03 Option Agreements',
        nb: '03 Option Agreements',
        key: 'DD03_Option_Agreements',
        children: [],
      },
      {
        en: '04 Overview of Pension Insurance etc',
        nb: '04 Overview of Pension Insurance etc',
        key: 'DD04_Overview_of_Pension_Insurance_etc',
        children: [],
      },
      {
        en: '05 Employee Handbook',
        nb: '05 Employee Handbook',
        key: 'DD05_Employee_Handbook',
        children: [],
      },
    ],
  },
  {
    en: '04 Finance',
    nb: '04 Finance',
    key: 'DD04_Finance',
    children: [
      {
        en: '01 Latest Financial Statements',
        nb: '01 Latest Financial Statements',
        key: 'DD01_Latest_Financial_Statements',
        children: [],
      },
      {
        en: '02 Current Year Budget',
        nb: '02 Current Year Budget',
        key: 'DD02_Current_Year_Budget',
        children: [],
      },
      {
        en: '03 Financial Model',
        nb: '03 Financial Model',
        key: 'DD03_Financial_Model',
        children: [],
      },
      {
        en: '04 Debtor Agreements - Loans Leasing etc',
        nb: '04 Debtor Agreements - Loans Leasing etc',
        key: 'DD04_Debtor_Agreements_-_Loans_Leasing_etc',
        children: [],
      },
      {
        en: '05 Creditor Agreements - Loans Leasing etc',
        nb: '05 Creditor Agreements - Loans Leasing etc',
        key: 'DD05_Creditor_Agreements_-_Loans_Leasing_etc',
        children: [],
      },
      {
        en: '06 Overview of Financial Subsidies',
        nb: '06 Overview of Financial Subsidies',
        key: 'DD06_Overview_of_Financial_Subsidies',
        children: [],
      },
    ],
  },
  {
    en: '05 Sales',
    nb: '05 Sales',
    key: 'DD05_Sales',
    children: [
      {
        en: '01 Customer List',
        nb: '01 Customer List',
        key: 'DD01_Customer_List',
        children: [],
      },
      {
        en: '02 Sales Pipeline',
        nb: '02 Sales Pipeline',
        key: 'DD02_Sales_Pipeline',
        children: [],
      },
      {
        en: '03 Sales Forecast',
        nb: '03 Sales Forecast',
        key: 'DD03_Sales_Forecast',
        children: [],
      },
      {
        en: '04 Customer Contracts',
        nb: '04 Customer Contracts',
        key: 'DD04_Customer_Contracts',
        children: [],
      },
    ],
  },
  {
    en: '06 Product',
    nb: '06 Product',
    key: 'DD06_Product',
    children: [
      {
        en: '01 Product Descriptions',
        nb: '01 Product Descriptions',
        key: 'DD01_Product_Descriptions',
        children: [],
      },
      {
        en: '02 Licenses and Rights',
        nb: '02 Licenses and Rights',
        key: 'DD02_Licenses_and_Rights',
        children: [],
      },
      {
        en: '03 Subcontractors',
        nb: '03 Subcontractors',
        key: 'DD03_Subcontractors',
        children: [],
      },
      {
        en: '04 Product Roadmap',
        nb: '04 Product Roadmap',
        key: 'DD04_Product_Roadmap',
        children: [],
      },
      {
        en: '05 Overview of IPR',
        nb: '05 Overview of IPR',
        key: 'DD05_Overview_of_IPR',
        children: [],
      },
    ],
  },
  { en: '07 Legal', nb: '07 Legal', key: 'DD07_Legal', children: [] },
  {
    en: '08 Market',
    nb: '08 Market',
    key: 'DD08_Market',
    children: [
      {
        en: '01 Strategy Process and Results',
        nb: '01 Strategy Process and Results',
        key: 'DD01_Strategy_Process_and_Results',
        children: [],
      },
      {
        en: '02 Business Plan',
        nb: '02 Business Plan',
        key: 'DD02_Business_Plan',
        children: [],
      },
      {
        en: '03 Competitors',
        nb: '03 Competitors',
        key: 'DD03_Competitors',
        children: [],
      },
    ],
  },
];
